import React from 'react';

const HospitalList = ({ hospitalList }) => {
    return (
        <div className="group-list">
            {hospitalList?.map((group, index) => (
                <div className="group-item" key={index}>
                    <img src={group.pictureUrl || '/user-avater.png'} alt={group.name} className="group-image" />
                    <div className="group-info">
                        <p className="group-title">{group.name}</p>
                        <p className="group-meta">{group?.email}</p>
                        <p className="group-meta">{group?.location}</p>

                    </div>
                </div>
            ))}
        </div>
    );
};

export default HospitalList;